
import { Reducer } from "react";
import { StoryEntitiesState, StoryEntityKnownAction, GET_STORY, GET_STORY_SUCCESS, GET_STORY_FAIL, GET_FILE_SUCCESS } from "./types";

const initialState: StoryEntitiesState = {
    stories: {},
    files: {},
    loading: false,
    error: {
        message: '',
        status: 0
    },
};



const reducer: Reducer<StoryEntitiesState, StoryEntityKnownAction> = (
    state: StoryEntitiesState | undefined = initialState,
    action: StoryEntityKnownAction,
) => {
    switch (action.type) {
        case GET_STORY:
            return {
                ...state,
                loading: true,
            };
        case GET_STORY_SUCCESS:
            return {
                ...state,
                loading: false,
                stories: {
                    ...state.stories,
                    [action.payload.perm_id]: action.payload
                },
            };
        case GET_FILE_SUCCESS:
            return {
                ...state,
                loading: false,
                files: {
                    ...state.files,
                    [action.payload.id]: action.payload
                },
            };
        case GET_STORY_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        default:
            return state;
    }
};

export default reducer;